export function loadVLibras() {
  if (window.__vLibrasLoaded) return;

  const script = document.createElement('script');
  script.src = 'https://vlibras.gov.br/app/vlibras-plugin.js';
  script.async = true;

  script.onload = () => {
    new window.VLibras.Widget('https://vlibras.gov.br/app');
    window.__vLibrasLoaded = true;
  };

  document.body.appendChild(script);
}
